import React, { ReactElement } from 'react';
import { Icon, ICON_NAME } from 'b2b-components/theme/components/Icon';
import { upperCaseFirst } from 'b2b-apps/shop/common/utils/string/string';
import { ComponentType, Props } from './';

enum TOAST_TYPE {
  info = 'info',
  warning = 'warning',
  error = 'error',
  success = 'success',
}

const Toast: ComponentType = ({
  type,
  header,
  content,
}: Props): ReactElement => (
  <div
    className={`cds-Toast cds-Toast--${upperCaseFirst(type)}`}
    data-test="toast"
  >
    <Icon
      name={`IconAlert${upperCaseFirst(type)}` as ICON_NAME}
      className="cds-Toast-Icon"
    />
    <Icon name={ICON_NAME.close} className="cds-Toast-Close" />
    {header ? <div className="cds-Toast-Header">{header}</div> : null}
    {content}
  </div>
);

export { Toast, TOAST_TYPE };
